// extracted by mini-css-extract-plugin
export default {"icon":"Arrow_icon__LIojb"};